module.exports = __webpack_public_path__ + "img/zhuangxiu_bg2.f23fe4ce.png";